import "../../../../styles/page/shoppingCart.scss";

import Icon, {iconTypes} from "../../../common/components/Icon.jsx";

import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

/**
 * Renders an empty shopping cart
 * @returns {node}
 */
export default function EmptyEditListCart({listHeight, localization}) {
    return (
        <div className="shopping-cart-empty-wrapper" style={{height:`${listHeight}px`}}>
            <div className="shopping-cart-empty-container">
                <div className="icon-bg">
                    <Icon type={iconTypes.boxAdd} opacity={0.2} className="shopping-cart-empty-icon"/>
                </div>
                <div className="shopping-cart-empty-text-header">
                    {localization.text("list", "letsAddToList")}
                </div>
                <div className="shopping-cart-empty-text">
                    {localization.text("list", "emptyOrderInfo1")}
                </div>
                <div className="shopping-cart-empty-text-line2">
                    {localization.text("list", "emptyOrderInfo2")}
                    <div className="shopping-cart-empty-text-line2-add">+</div>
                    {localization.text("list", "emptyOrderInfo3")}
                </div>
            </div>
        </div>
    );
}

EmptyEditListCart.propTypes = {
    localization: Localization.propTypes.isRequired,
    listHeight: PropTypes.number.isRequired,
};